export const PatchSetBorrowerCashInCashOutMethodToLoan = {
  dehydrate(data) {
    return {
      op: "processPatchSetBorrowerCashInCashOutMethodToLoan",
      id: data.id,
      cash_in_cash_out_method_id: data.cashInCashOutMethodId,
    };
  },
};
